var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { LoginService } from "~/services/management-service/login.service";
import { Emit } from "vue-property-decorator";
var WorkPassword = /** @class */ (function (_super) {
    __extends(WorkPassword, _super);
    function WorkPassword() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.passwordModel = {
            oldPassword: "",
            newPassword: "",
            confirmPassword: '',
        };
        // 数据校验规则
        _this.rules = {
            oldPassword: [
                { required: true, message: "请输入原密码", trigger: "blur" },
                {
                    min: 6,
                    max: 64,
                    message: "密码长度不能小于6位大于64位",
                    trigger: "blur"
                }
            ],
            newPassword: [
                { required: true, message: "请输入新密码", trigger: "blur" },
                {
                    min: 6,
                    max: 64,
                    message: "密码长度不能小于6位大于64位",
                    trigger: "blur"
                }
            ],
            confirmPassword: [
                { required: true, message: "请再次输入新密码", trigger: "blur" },
                { validator: _this.validatePassword, trigger: "blur" },
                {
                    min: 6,
                    max: 64,
                    message: "密码长度不能小于6位大于64位",
                    trigger: "blur"
                }
            ]
        };
        return _this;
    }
    WorkPassword.prototype.close = function () {
        this.reset();
    };
    /**
     * 验证密码
     */
    WorkPassword.prototype.validatePassword = function (rule, value, callback) {
        var pwd = this.passwordModel.newPassword;
        var repwd = this.passwordModel.confirmPassword;
        if (pwd !== "" && repwd !== "" && pwd !== repwd) {
            callback(new Error("请确认两次输入密码是否一致"));
        }
        else {
            callback();
        }
    };
    /**
     * 确定
     */
    WorkPassword.prototype.confirm = function () {
        var _this = this;
        this.passwordForm.validate(function (valid) {
            if (!valid) {
                return false;
            }
            if (_this.passwordModel.oldPassword === _this.passwordModel.newPassword) {
                _this.$message.info('新密码和原始密码相同');
                return false;
            }
            _this.loginService
                .updatePassword({
                oldPassword: _this.passwordModel.oldPassword,
                newPassword: _this.passwordModel.newPassword
            })
                .subscribe(function (data) {
                _this.$message.success("修改密码成功");
                _this.close();
            });
        });
    };
    WorkPassword.prototype.reset = function () {
        this.passwordForm.resetFields();
    };
    WorkPassword.prototype.mounted = function () {
        this.passwordForm = this.$refs["password-form"];
    };
    __decorate([
        Dependencies(LoginService)
    ], WorkPassword.prototype, "loginService", void 0);
    __decorate([
        Emit("close")
    ], WorkPassword.prototype, "close", null);
    WorkPassword = __decorate([
        Component({
            components: {}
        })
    ], WorkPassword);
    return WorkPassword;
}(Vue));
export default WorkPassword;
